import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from "chart.js";

@Component({
  selector: 'app-doughnut-chart-global-patients',
  templateUrl: './doughnut-chart-global-patients.component.html',
  styleUrls: ['./doughnut-chart-global-patients.component.css']
})
export class DoughnutChartGlobalPatientsComponent implements OnInit, OnDestroy {
  //
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription5: Subscription;
  title = "Pazienti globali";
  destination = 'general-status';
  // ******************************************************************************************************************
  // inizializzazione per i doughnut charts sul numero di utenti per malattia
  // ******************************************************************************************************************
  //
  isHovered = false;
  public totalPatients = 0;
  // ******************************************************************************************************************
  // Grafici doughnut per il numero di pazienti globali e personali divisi per tipo di malattia
  // ******************************************************************************************************************
  public colorsOptions = [{
    backgroundColor: [
      '#ff9933',
      '#336699',
      '#66ccff',
    ],
    hoverbackgroundColor: [
      '#c46200',
      '#214262',
      '#0098e5',
    ]
  }];
  public doughnutChartOptions = {
    legend: {
      onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
        // tslint:disable-next-line:max-line-length
        if (legendItem.text.length > 0 && (legendItem.text === 'Crohn' || legendItem.text === 'Rettocolite Ulcerosa' || legendItem.text === 'Altro')) {
          this.setHoverVariable();
        } else {
          this.unsetHoverVariable();
        }
      },
      display: true,
      position: 'top',
      align: 'left',
      textDirection: 'ltr',
      labels: {
        usePointStyle: true,
        fontColor: '#006192',
        fontSize: 18,
        fontFamily: 'Helvetica',
      }
    },
    cutoutPercentage: 70,
    tooltips: {
      content: '{pathology}: {number}',
      backgroundColor: '#1c1c1c',
      titleColor: '#f0d7f7',
      bodyFontSize: 18,
      titleFontSize: 18,
      cornerRadius: 5,
      caretPadding: 10
    }
  };
  public headElements = ['pathology', 'number'];
  public elements: any = [
    {pathology: '', number: ''},
    {pathology: '', number: ''},
    {pathology: '', number: ''},
    {total: ''}
  ];
  public elementsD: any = [
    {pathology: '', number: ''},
    {pathology: '', number: ''},
    {pathology: '', number: ''},
    {total: ''}
  ];
  public doughnutChartLabels = ['Crohn', 'Rettocolite Ulcerosa', 'Altro'];
  public doughnutChartData = []; // sono i dati che vanno presi dal database tramite delle richieste
  public doughnutChartDataDoctor = []; // sono i dati che vanno presi dal database, riferiti ai pazienti del singolo medico
  public doughnutChartType = 'doughnut';
  constructor(private store: Store<AppState>,
              private doctorService: DoctorService) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState); }

  ngOnInit(): void {
    this.subscription5 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrievedata1();
    });
  }
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription5.unsubscribe();
  }

  // funzioni per i numeri globali dei pazienti in base alla malattia, sia per i pazienti personali e
  // globali ( doughnut chart)
  retrievedata1() {
    // prendo dal database il numero di tutti i pazienti che soffrono della Mattia di Crohn
    this.subscription1 = this.doctorService.getAllCrohnPatientsNumber().subscribe(
      allCrohnPatientsNumber => {
        localStorage.setItem('AllCPatients', allCrohnPatientsNumber.toString());
        this.doughnutChartData[0] = allCrohnPatientsNumber;
        this.elements[0].pathology = 'Malattia di Crohn';
        this.elements[0].number = allCrohnPatientsNumber.toString();
        this.totalPatients = +parseInt(allCrohnPatientsNumber.toString());
        this.retrievedata2();
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }
  retrievedata2() {
    // prendo dal database il numero di tutti i pazienti che soffrono di colite ulcerosa
    this.subscription2 = this.doctorService.getAllColiteUlcerosaPatientsNumber().subscribe(
      allColitePatientsNumber => {
        localStorage.setItem('AllUCPatients', allColitePatientsNumber.toString());
        this.doughnutChartData[1] = allColitePatientsNumber;
        this.elements[1].pathology = 'Rettocolite Ulcerosa';
        this.elements[1].number = allColitePatientsNumber.toString();
        this.totalPatients += parseInt(allColitePatientsNumber.toString());
        this.retrievedata3();
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }
  retrievedata3() {
    // prendo dal database il numero di tutti i pazienti che soffrono di altro
    this.subscription3 = this.doctorService.getAllAltroPatientsNumber().subscribe(
      allAltroPatients => {
        localStorage.setItem('AllAPatients', allAltroPatients.toString());
        this.doughnutChartData[2] = allAltroPatients;
        this.elements[2].pathology = 'Altro';
        this.elements[2].number = allAltroPatients.toString();
        this.totalPatients += parseInt(allAltroPatients.toString());
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }
  // set hovered variable of Never Logged
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable of Never Logged
  unsetHoverVariable(): void {
    this.isHovered = false;
  }

}
